"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SwPage',
  props: ["listQuery", "total", "pos"],
  data: function data() {
    return {
      layout: "prev, pager, next, jumper",
      cls: "page-cont-left"
    };
  },
  created: function created() {
    if ("topLeft" === this.pos) {
      this.layout = "prev, pager, next, jumper";
      this.cls = "page-cont-left";
    } else if ("btmRight" === this.pos) {
      this.layout = "total, sizes, prev, pager, next, jumper";
      this.cls = "page-cont-btm-right";
    } else {
      this.layout = "prev, pager, next, jumper";
      this.cls = "page-cont-left";
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.$emit("retPage");
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.$emit("retPage");
    }
  }
};